export * from './stuallot/stuallot.component';
export * from './assignact/assignact.component';